(() => {
  const getTransitionMs = (el) => {
    if (!el) return 0;

    const s = getComputedStyle(el);
    const dur = (s.transitionDuration || '0s').split(',')[0].trim();
    const del = (s.transitionDelay || '0s').split(',')[0].trim();

    const toMs = (v) => (v.endsWith('ms') ? parseFloat(v) : parseFloat(v) * 1000);
    return toMs(dur) + toMs(del);
  };

  function initMenuOverlayClose() {
    const container = document.getElementById('Details-menu-drawer-container');
    if (!container) return;

    const summary = container.querySelector('summary');
    const overlay = container.querySelector('#MenuDrawer-Overlay'); // ONLY this one
    const drawer  = container.querySelector('#menu-drawer');

    if (!summary || !overlay) return;

    if (overlay.dataset.closeDrawerBound === '1') return;
    overlay.dataset.closeDrawerBound = '1';

    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      if (!container.open) return;

      // Close any nested submenu <details> first (prevents “stuck” states)
      container.querySelectorAll('details[open]').forEach((d) => {
        if (d !== container) d.open = false;
      });

      // This gives you Dawn’s *native* close animation
      summary.click();

      // Fallback only AFTER the drawer transition should have finished
      const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wait = prefersReduced ? 0 : (getTransitionMs(drawer) || 300);

      window.setTimeout(() => {
        if (container.open) container.open = false;
        container.classList.remove('menu-opening');
        summary.setAttribute('aria-expanded', 'false');
      }, wait + 50);
    });
  }

  document.addEventListener('DOMContentLoaded', initMenuOverlayClose);
  document.addEventListener('shopify:section:load', initMenuOverlayClose);
})();
